

export class EmployeeGroupBranchDetailsOutput implements IEmployeeGroupBranchDetailsOutput {
    /** The auto-generated id of the branch details master */
    branch_detail_id!: number;

    constructor(data?: IEmployeeGroupBranchDetailsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branch_detail_id = _data["branch_detail_id"];
        }
    }

    static fromJS(data: any): EmployeeGroupBranchDetailsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeGroupBranchDetailsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branch_detail_id"] = this.branch_detail_id;
        return data; 
    }
}

export interface IEmployeeGroupBranchDetailsOutput {
    /** The auto-generated id of the branch details master */
    branch_detail_id: number;
}

